import { PopupDetailProfileProps } from "./popup-detail-profile.types";
import { PopupDetailProfileSkin1 } from "./skins/popup-detail-profile-skin-1";

export const PopupDetailProfile = (props: PopupDetailProfileProps) => {
  return <PopupDetailProfileSkin1 {...props} />;
};
